/* Post titles and excerpts come straight from Ghost, so two house habits get
 * cleaned up here, once, for every list that opts in:
 *
 * 1. Series prefixes. Recurring posts are titled "ECONOMIC WEEK AHEAD:
 *    September 14–18". The all-caps prefix comes off the title and, title-
 *    cased ("Economic Week Ahead"), becomes the first item of the card's
 *    [data-series-slot] — normally its .meta-line, which draws the "·"
 *    separators itself. Only fires on a genuinely all-caps prefix ending in a
 *    colon. A card with no slot keeps its title untouched;
 *    data-series-title="drop" strips the prefix without a label (the webcast
 *    band, where "WEEKLY WEBCAST" is redundant).
 *
 * 2. Outline numerals. Ed's posts open on "I. Yen-Carry Trade Unwinding?", and
 *    Ghost's auto-excerpt starts there. [data-excerpt] drops a leading roman
 *    numeral. A custom excerpt in Ghost is still the better fix per post. */
(function () {
    var KEEP_UPPER = /^(S&P|NASDAQ|GDP|CPI|PCE|PPI|US|USA|UK|EU|EPS|ETF|ETFS|AI|FOMC|ECB|BOJ|PBOC|PE|P\/E|VIX|DXY|MSCI|EM|DJIA|OECD|ISM|PMI|QE|QT|WTI|OPEC|IPO|M&A|Q&A|YTD|MAG-7)$/;
    var SMALL = /^(a|an|and|as|at|by|for|from|in|of|on|or|the|to|vs\.?|via|with)$/;
    function titleCase(t) {
        return t.split(/(\s+)/).map(function (w, i) {
            if (/^\s+$/.test(w) || !/[A-Z]/.test(w)) return w;
            if (KEEP_UPPER.test(w)) return w;
            var lower = w.toLowerCase();
            if (i > 0 && SMALL.test(lower)) return lower;
            return lower.charAt(0).toUpperCase() + lower.slice(1);
        }).join('');
    }

    document.querySelectorAll('[data-series-title]').forEach(function (el) {
        var m = el.textContent.trim().match(/^([A-Z][A-Z0-9&'’.\s-]{2,40}):\s+(.+)$/);
        if (!m || m[1] !== m[1].toUpperCase()) return;
        var drop = el.getAttribute('data-series-title') === 'drop';
        var card = el.closest('[data-post-card]');
        var slot = card && card.querySelector('[data-series-slot]');
        if (!drop && !slot) return;
        el.textContent = m[2];
        if (drop) return;
        var label = document.createElement('span');
        label.className = 'text-ink';
        label.textContent = titleCase(m[1].trim());
        // After a fixed lead item ("Latest post"), otherwise first
        var lead = slot.querySelector('[data-meta-lead]');
        slot.insertBefore(label, lead ? lead.nextSibling : slot.firstChild);
    });

    document.querySelectorAll('[data-excerpt]').forEach(function (el) {
        var t = el.textContent.replace(/^\s*[IVX]{1,5}\.\s+/, '');
        if (t !== el.textContent) el.textContent = t;
    });
})();

/* Ticker bar (partials/yqt/ticker-bar.hbs, every page). Fills each item from
 * market-data.json (per-minute during market hours); items whose symbol
 * isn't in the feed keep their "—". Teal up, red down. */
(function () {
    const tiles = document.querySelectorAll('[data-market-tile]');
    if (!tiles.length) return;

    const bust = Math.floor(Date.now() / 60000);
    fetch('https://bu2teaoyba4t7viw.public.blob.vercel-storage.com/market-data.json?t=' + bust)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (data) {
            const quotes = (data && data.quotes) || [];
            tiles.forEach(function (tile) {
                const symbol = tile.getAttribute('data-symbol');
                const quote = quotes.find(function (q) { return q.symbol === symbol; });
                if (!quote || typeof quote.changePercent !== 'number') return;

                const isYield = tile.getAttribute('data-kind') === 'yield';
                const pct = quote.changePercent;
                const up = pct >= 0;
                // Yields: readers think in basis points, and "+0.20%" is ambiguous there.
                const formatted = isYield && typeof quote.change === 'number'
                    ? (up ? '+' : '−') + Math.abs(Math.round(quote.change * 100)) + ' bp'
                    : (up ? '+' : '−') + Math.abs(pct).toFixed(2) + '%';

                const level = tile.querySelector('[data-market-level]');
                if (level && isYield && typeof quote.price === 'number') level.textContent = quote.price.toFixed(2) + '%';

                const pill = tile.querySelector('[data-market-pct]');
                if (pill) {
                    pill.textContent = formatted;
                    pill.classList.remove('text-ink-subtle');
                    pill.classList.toggle('text-teal', up);
                    pill.classList.toggle('text-negative', !up);
                }
            });

            const asof = document.querySelector('[data-market-asof]');
            const stamp = data && data.asOf && new Date(data.asOf);
            if (asof && stamp && !isNaN(stamp)) {
                const t = new Intl.DateTimeFormat('en-US', {
                    hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York', timeZoneName: 'short'
                }).format(stamp);
                asof.textContent = 'As of ' + t;
                asof.hidden = false;
            }
        })
        .catch(function () { /* keep static fallbacks */ });
})();

/* Subtle 3D tilt on book covers in Ed's library — pointer-fine only
 * so touch devices (which have no real hover) are unaffected.
 * Kept at the top of the file so a throw from any legacy Source IIFE
 * below doesn't halt script execution before this IIFE runs. */
(function () {
    if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const MAX_TILT = 7; // degrees

    document.querySelectorAll('[data-book-tilt]').forEach(function (card) {
        const cover = card.querySelector('[data-book-cover]');
        if (!cover) return;

        card.addEventListener('pointermove', function (e) {
            const rect = cover.getBoundingClientRect();
            // Clamp to [-0.5, 0.5] — PTM's anchor extends well past its cover,
            // so hovering the text side would otherwise push tilt past MAX_TILT.
            const clamp = function (v) { return Math.max(-0.5, Math.min(0.5, v)); };
            const px = clamp((e.clientX - rect.left) / rect.width - 0.5);
            const py = clamp((e.clientY - rect.top) / rect.height - 0.5);
            cover.style.setProperty('--tilt-y', (px * 2 * MAX_TILT).toFixed(2) + 'deg');
            cover.style.setProperty('--tilt-x', (py * -2 * MAX_TILT).toFixed(2) + 'deg');
        });

        card.addEventListener('pointerleave', function () {
            cover.style.setProperty('--tilt-x', '0deg');
            cover.style.setProperty('--tilt-y', '0deg');
        });
    });
})();

/* Mobile menu burger toggle — legacy Source selectors; our yqt/nav
 * partial ships its own toggle, so just no-op when the old markup
 * isn't present instead of throwing and poisoning later scripts
 * (including Ghost Portal's init). */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    try {
        lightbox(
            '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
        );
    } catch (e) { /* legacy Source helper; no-op if its deps aren't loaded */ }
})();

/* Responsive video in post content */
(function () {
    try {
        const sources = [
            '.gh-content iframe[src*="youtube.com"]',
            '.gh-content iframe[src*="youtube-nocookie.com"]',
            '.gh-content iframe[src*="player.vimeo.com"]',
            '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
            '.gh-content object',
            '.gh-content embed',
        ];
        reframe(document.querySelectorAll(sources.join(',')));
    } catch (e) { /* legacy Source helper; no-op if its deps aren't loaded */ }
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items.
 * The legacy helper assumes Source-theme markup we don't ship, so isolate the
 * throw in a try/catch — otherwise it halts script execution for the rest of
 * the page and breaks Ghost Portal. */
(function () {
    try {
        dropdown();
    } catch (e) { /* legacy Source helper; no-op when markup is missing */ }
})();

/* Infinite scroll pagination */
(function () {
    try {
        if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
            pagination();
        }
    } catch (e) { /* legacy Source helper; no-op if its deps aren't loaded */ }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
